/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactLightDto } from '../../models/sales-contact-light-dto';

export interface ContactsControllerFindLightByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;
}

export function contactsControllerFindLightByTenant(http: HttpClient, rootUrl: string, params: ContactsControllerFindLightByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContactLightDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerFindLightByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesContactLightDto>>;
    })
  );
}

contactsControllerFindLightByTenant.PATH = '/o2-sales/contacts/{tenant}/light';
